module.exports = __webpack_public_path__ + "static/Tania_Parents-9b4aeff41c4cbb5635c900e92abed231.jpg";